import { Obs } from "@/Common/Obs";
import { tpOnError } from "@/Hubs/BaseHub";
import { ImportOrderHub } from "@/Hubs/ImportOrderHub";
import { ViewImportOrder } from "@/Models/Views/ViewImportOrder";
import { createContext } from "react";

export class ImportOrderHubProvider {
    hub: ImportOrderHub;
    constructor(onError: tpOnError) {
        this.hub = new ImportOrderHub(onError);
        this.hub.on("ExecuteFlagChange", this._dataChange);
        this.hub.on("Add", s => this.data.Value = [...this.data.Value, ...s]);
        this.hub.start(async () => {
            this.loading.Value = true;
            try {
                this.data.Value = await this.hub.getUnFinishedList();
            } catch (error) {
                console.log(error);
            }
            finally {
                this.loading.Value = false;
            }
        });
    }

    private _dataChange = (data: ViewImportOrder) => {
        const index = this.data.Value.findIndex(s => s.id === data.id);
        if (index > -1) {
            const items = [...this.data.Value];
            if (data.executeFlag === "Finished" || data.executeFlag === "Cancel") {
                items.splice(index, 1);
            }
            else {
                items[index] = data;
            }
            this.data.Value = items;
        }
    }
    public loading = new Obs(false);
    public data = new Obs<ViewImportOrder[]>([]);
}

export const ImportOrderHubProviderContext = createContext<ImportOrderHubProvider>(null as any);